export const init = () => {
  if (tc_vars.env_template !== 'checkout') return;

  /* ENHANCED E-COMMERCE - IMPRESSION - BASKET */

  const fwk = CUBE.Analytics;

  const classProductViewed = 'viewed';

  /**
   * IMPRESSION on SCROLL FOR LAST VIEWED PRODUCTSÒ
   */
  $(window).on('scroll', () => {
    $('.savelater-element').each(function() {
      setProductSaveLaterAsViewed($(this));
    });
  });

  const getVadaInfo = $product => {
    const $vada = $product.find('[data-universe]');
    return {
      family: $vada.data('family') || '',
      department: $vada.data('department') || '',
      subdepartment: $vada.data('subdepartment') || '',
      universe: $vada.data('universe') || '',
    };
  };

  /*
   *  IMPRESSIONS - SAVE LATER PRODUCTS
   */
  const pool = [];
  const setProductSaveLaterAsViewed = $product => {
    if (fwk.utils.isVisible($product) && !$product.hasClass(classProductViewed)) {
      const refId = $product.find('[data-catalogrefid]').data('catalogrefid');

      const model = fwk.utils.datalayer.getModel(refId);
      model.list = '/checkout/cart';
      model.vada = getVadaInfo($product);

      if (pool.includes(refId)) {
        fwk.enhanced.sendImpression(model);
        $product.addClass(classProductViewed);
        pool.push(refId);
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-1-impression-basket.js